'use strict';

var _ = require('lodash');
var FaresAverageFaresInversionService = function FaresAverageFaresInversionService($q, dataRetrieverService, dataRetrieverConstantsService, currentStateCriteriaService, SearchCriteriaRule, mappedFaresInversionService) {
  function prepareKey(element) {
    return element.market + '+' + element.spos + '+' + element.cabinCode;
  }
  function prepareGroupingKey(element) {
    return element.market + '+' + element.spos;
  }
  function prepareRange(element) {
    return [element.applicableDateRangeBegin.valueOf(), element.applicableDateRangeEnd.valueOf()];
  }
  function mergeGridAndRequestRows(faresRowsFromRequest, faresRowsFromGrid) {
    function isEqual(fromGrid, fromRequest) {
      return clonedFaresRowsFromGrid[j].userFare !== undefined && fromGrid.bookingClass === fromRequest.className && fromGrid.spos === fromRequest.spos && fromGrid.market === fromRequest.market && fromGrid.applicableDateRangeBegin.isSame(fromRequest.applicableDateRangeBegin) && fromGrid.applicableDateRangeEnd.isSame(fromRequest.applicableDateRangeEnd);
    }
    var clonedFaresRowsFromGrid = _.cloneDeep(faresRowsFromGrid);
    for (var i = 0, dataLength = faresRowsFromRequest.length; i < dataLength; i++) {
      for (var j = 0, faresLength = clonedFaresRowsFromGrid.length; j < faresLength; j++) {
        faresRowsFromRequest[i].fare = faresRowsFromRequest[i].userFare || faresRowsFromRequest[i].fare;
        if (isEqual(clonedFaresRowsFromGrid[j], faresRowsFromRequest[i])) {
          faresRowsFromRequest[i].fare = clonedFaresRowsFromGrid[j].userFare;
          faresRowsFromRequest[i].totalFare = clonedFaresRowsFromGrid[j].userFare + clonedFaresRowsFromGrid[j].surcharge;
        }
      }
      faresRowsFromRequest[i]._key = prepareKey(faresRowsFromRequest[i]);
      faresRowsFromRequest[i]._groupingKey = prepareGroupingKey(faresRowsFromRequest[i]);
      faresRowsFromRequest[i]._range = prepareRange(faresRowsFromRequest[i]);
    }
    return faresRowsFromRequest;
  }
  function retrieveAllData(firstFareMarket) {
    var timeAndDateCategoryName = 'Time & Date';
    var marketCriterionName = 'Market';
    function getFaresSearchCriteria() {
      var criteria = currentStateCriteriaService.getSearchCriteria();
      var rules = criteria.rules;
      var searchWithNecessaryRules = _.filter(rules, function (rule) {
        return !(rule.category === timeAndDateCategoryName || rule.criterion === marketCriterionName);
      });
      searchWithNecessaryRules.push(new SearchCriteriaRule({
        category: 'Location',
        metaCategory: 'Mkt Location',
        shortCriterionName: 'Mkt',
        criterion: marketCriterionName,
        operator: '=',
        field: 'custom:faresMarket',
        searchContext: 'fares',
        leftOperand: [firstFareMarket],
        rightOperand: '',
        isReadOnly: true
      }));
      return searchWithNecessaryRules;
    }
    var dataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FARES_SCREEN, dataRetrieverConstantsService.FARES_INVERSION_MODE);
    dataRetriever.setCustomSearchCriteriaRules($q.when(getFaresSearchCriteria()));
    dataRetriever.defaultSortDefer.resolve();
    return dataRetriever.retrieveComponentData('fares-inversion');
  }
  function isInversion(rowsToCheck) {
    var prevElement;
    var possibleInversions = [];
    var result = {};
    function checkFaresInversionCondition(elementToCheck, possibleInversion) {
      return elementToCheck.classIndex > possibleInversion.classIndex && elementToCheck.totalFare > possibleInversion.totalFare;
    }
    function checkIntersectionsAndInversionWithPreviousElements(elementToCheck) {
      _.forEach(possibleInversions, function (possibleInversion) {
        var test1 = possibleInversion._range;
        var test2 = elementToCheck._range;
        var maxOfLeftSides = _.max([test1[0], test2[0]]);
        var minOfRightSides = _.min([test1[1], test2[1]]);
        if (maxOfLeftSides <= minOfRightSides && checkFaresInversionCondition(elementToCheck, possibleInversion)) {
          result['' + possibleInversion._key + '*' + possibleInversion.className] = possibleInversion;
          result['' + elementToCheck._key + '*' + elementToCheck.className] = elementToCheck;
        }
      });
    }
    var dataWithClassProperty = _.filter(rowsToCheck, 'classIndex');
    dataWithClassProperty = _.filter(dataWithClassProperty, {
      ignoreForecastRegular: false
    });
    var sorterByMarket = _.sortBy(dataWithClassProperty, ['_key', 'classIndex']);
    _.forEach(sorterByMarket, function (element) {
      if (!prevElement || prevElement._key !== element._key) {
        possibleInversions.length = 0;
      } else {
        checkIntersectionsAndInversionWithPreviousElements(element);
      }
      possibleInversions.push(element);
      prevElement = element;
    });
    return _.values(result).length > 0;
  }
  function isFaresInversion(faresRows, isAvgFareGrid) {
    var faresRowsFromGrid = _.cloneDeep(faresRows);
    var userFareFieldName = isAvgFareGrid ? 'userFare' : 'userMappedFare';
    function mergeGroupAndDetectInversions(faresRowsFromRequest) {
      var finalInversionCheckResult = false;
      var mergedData = mergeGridAndRequestRows(faresRowsFromRequest, faresRowsFromGrid);
      _.chain(mergedData).groupBy('_groupingKey').each(function (rowsToCheck) {
        if (!finalInversionCheckResult) {
          finalInversionCheckResult = isInversion(rowsToCheck);
        }
      }).value();
      return finalInversionCheckResult;
    }
    faresRowsFromGrid = _.filter(faresRows, userFareFieldName);
    if (faresRowsFromGrid.length === 0) {
      return $q.when(false);
    }
    if (!isAvgFareGrid) {
      return mappedFaresInversionService.isMappedFaresInversion(faresRows);
    }
    var firstFare = _.first(faresRowsFromGrid);
    return retrieveAllData(firstFare.origin + '-' + firstFare.destination).then(mergeGroupAndDetectInversions);
  }
  return {
    isFaresInversion: isFaresInversion,
    isInversion: isInversion
  };
};
FaresAverageFaresInversionService.$inject = ['$q', 'DataRetrieverService', 'DataRetrieverConstantsService', 'CurrentStateCriteriaService', 'SearchCriteriaRuleFactory', 'MappedFaresInversionService'];
module.exports = FaresAverageFaresInversionService;